__turbopack_context__.v({
  "avatarButton": "viMOla_avatarButton",
  "bag-btn": "viMOla_bag-btn",
  "cart-count": "viMOla_cart-count",
  "cart-quantity": "viMOla_cart-quantity",
  "cart-quantity--large": "viMOla_cart-quantity--large",
  "currency-menu": "viMOla_currency-menu",
  "iconBtn": "viMOla_iconBtn",
  "initial": "viMOla_initial",
  "item": "viMOla_item",
  "itemReset": "viMOla_itemReset",
  "list": "viMOla_list",
  "loggedInButton": "viMOla_loggedInButton",
  "loggedInItem": "viMOla_loggedInItem",
  "root": "viMOla_root",
  "search-display": "viMOla_search-display",
  "search-menu": "viMOla_search-menu",
  "stores": "viMOla_stores",
});
